<template>
  <div class="card">
      <div class="row no-gutters">
          <div class="col-auto" style="min-width: 200px; text-align: center;">
              <img style="max-width:200px" :src="parseLogo(entidad.logo_empresa)" class="img-fluid" alt="">
          </div>
          <div class="col" :style="{'width': '100%', 'background':parsedBack}">
              <div class="card-block px-2">
                  <h4 class="card-title">{{entidad.nombre_entidad}}</h4>
                  <p class="card-text">
                    <b-row>
                      <b-col>
                          <p class="card-text">
                              <strong>CIF:</strong> {{entidad.cif}}, <strong>SAP:</strong> {{entidad.codigo_entidad}}
                          </p>
                          <p class="card-text">
                            <template v-if="entidad.email_principal">
                              <a :href="'mailto:'+entidad.email_principal" target="_top">{{entidad.email_principal}}</a>
                            </template>
                            <template v-else>
                              Sin correo electrónico
                            </template>
                          </p>
                      </b-col>
                      <b-col style="text-align: right;">
                          <b-button :disabled="entidad.website === null" @click="openWeb">Visitar web</b-button>
                          <b-button class="btn btn-primary" @click="goToDetails">Ver detalles</b-button>
                          <template v-if="!entidad.disabled">
                            <b-button v-if="!selected" @click="select">Seleccionar</b-button>
                            <b-button v-else @click="deselect">Deseleccionar</b-button>
                          </template>
                      </b-col>
                    </b-row>
                  </p>
              </div>
          </div>
      </div>
  </div>
    <!-- <b-card
    :title="entidad.nombre_entidad"
    :style="{'width': '100%', 'background':parsedBack}"
    class="mb-2">
    <b-row>
        <b-col>
            <p class="card-text">
                <strong>CIF:</strong> {{entidad.cif}}, <strong>SAP:</strong> {{entidad.codigo_entidad}}
            </p>
            <p class="card-text">
              <template v-if="entidad.email_principal">
                <a :href="'mailto:'+entidad.email_principal" target="_top">{{entidad.email_principal}}</a>
              </template>
              <template v-else>
                Sin correo electrónico
              </template>
            </p>
        </b-col>
        <b-col style="text-align: right;">
            <b-button :disabled="entidad.website === null" @click="openWeb">Visitar web</b-button>
            <b-button class="btn btn-primary" @click="downloadFile(entidad.documentacion_comercial)" :disabled="entidad.documentacion_comercial === null">Ver documentación</b-button>
            <template v-if="!entidad.disabled">
              <b-button v-if="!selected" @click="select">Seleccionar</b-button>
              <b-button v-else @click="deselect">Deseleccionar</b-button>
            </template>
        </b-col>
    </b-row>
    </b-card> -->
</template>

<script>
// import saveAs from 'file-saver'

export default {
  name: 'Entidad',
  props: ['entidad'],
  data () {
    return {
      selected: false
    };
  },
  methods: {
    parseLogo: function (logo) {
      if (logo) {
        return logo.replace('api/entities_paginated', 'media');
      } else {
        return '//placehold.it/200';
      }
    },
    goToDetails: function () {
      let routeData = this.$router.resolve({name: 'Form', params: {document: this.entidad.id_web}});
      window.open(routeData.href, '_blank');
    },
    openWeb: function () {
      window.open(this.entidad.website, '_blank');
    },
    select: function () {
      this.$emit('select', this.entidad);
      this.selected = true;
    },
    deselect: function () {
      this.$emit('deselect', this.entidad);
      this.selected = false;
    }
  },
  computed: {
    parsedBack: function () {
      if (this.entidad.disabled) {
        return 'darkgray';
      } else if (this.selected) {
        return 'bisque';
      } else {
        return '';
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Modules/Map/Details/EntidadSlot.vue